import { useGetGroup } from '@repo/api/group/useGetGroup';
import { UserLvl } from '@repo/types/enums/userLvl';
import { useMemo } from 'react';
import { useParams } from 'react-router';

import GroupGradesPreview from '@/components/features/groups/GroupGradesPreview';
import GroupMeetings from '@/components/features/groups/GroupMeetings';
import GroupMembers from '@/components/features/groups/GroupMembers';
import GroupPosts from '@/components/features/groups/GroupPosts';
import GroupQuickMenu from '@/components/features/groups/GroupQuickMenu';
import GroupHeader from '@/components/features/groups/layout/GroupHeader';
import GroupPageErrorState from '@/components/features/groups/layout/GroupPageErrorState';
import ScheduleTimetable, { getScheduleTimetableEntries } from '@/components/features/schedule/ScheduleTimetable';
import { useCredentials } from '@/store/auth-store';

export default function GroupPage() {
  const { id } = useParams();
  const groupId = Number(id);
  const { data, isError, errorMessage } = useGetGroup(groupId);
  const { id: userId, lvl } = useCredentials();
  const isStudent = lvl === UserLvl.STUDENT;

  const meetings = useMemo(() => (data ? getScheduleTimetableEntries(data) : []), [data]);

  // Error state
  if (isError) {
    return <GroupPageErrorState errorMessage={errorMessage} />;
  }

  return (
    <div className="base-direction-col">
      <div className="grid w-full grow grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_20rem] lg:grid-rows-[min-content_1fr]">
        {/* Header - row 1 on desktop, order 1 on mobile */}
        <div className="order-1 flex min-w-0 flex-col gap-4 lg:order-0 lg:col-start-1 lg:row-start-1">
          <GroupHeader groupId={groupId} groupName={data?.name} groupAvatarURL={data?.avatarURL ?? undefined} />
          {isStudent && <GroupGradesPreview groupId={groupId} userId={userId} />}
        </div>

        {/* Right side content - row 1-2 on desktop, order 2 on mobile */}
        <div className="order-2 flex flex-col gap-4 lg:sticky lg:top-4 lg:order-0 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:max-h-[calc(100dvh-var(--spacing)*4*2)] lg:self-start lg:overflow-y-auto">
          <GroupMeetings groupId={Number(id)} />
          <GroupQuickMenu group={data} />
          <GroupMembers groupId={Number(id)} className="shrink-0" />
        </div>

        {/* Schedule + Posts - row 2 on desktop, order 3 on mobile (after right side) */}
        <div className="order-3 flex min-w-0 flex-col gap-4 lg:order-0 lg:col-start-1 lg:row-start-2">
          {data?.schedule && <ScheduleTimetable meetings={meetings} />}
          <GroupPosts groupId={groupId} />
        </div>
      </div>
    </div>
  );
}
